
import { mealPlanQueryService } from "./mealPlanQueryService";
import { mealPlanMutationService } from "./mealPlanMutationService";
import { mealPlanStatsService } from "./mealPlanStatsService";
import { MealType } from "@/types/mealPlan";

// Export individual services
export { mealPlanQueryService } from "./mealPlanQueryService";
export { mealPlanMutationService } from "./mealPlanMutationService";
export { mealPlanStatsService } from "./mealPlanStatsService";

/**
 * Consolidated meal plan service that combines query and mutation services
 */
export const mealPlanService = {
  // Query methods
  getMealPlans: mealPlanQueryService.getMealPlans,
  
  // Stats methods
  getTotalMealPlansCount: mealPlanStatsService.getTotalMealPlansCount,
  
  // Mutation methods - now supports both recipes and compositions with meal types
  saveMealPlan: (date: string, recipeId: string | null, familyId: string, mealType: MealType = 'dinner') => 
    mealPlanMutationService.saveMealPlan(date, recipeId, familyId, mealType),
  
  saveMealPlanComposition: (date: string, compositionId: string, familyId: string, mealType: MealType = 'dinner') =>
    mealPlanMutationService.saveMealPlanComposition(date, compositionId, familyId, mealType),
  
  deleteMealPlan: mealPlanMutationService.deleteMealPlan,
};

// Export default for consistency with other service modules
export default mealPlanService;
